import { Text } from "@mantine/core";
import { type Cell, flexRender, type Row } from "@tanstack/react-table";
import classNames from "classnames";

import styles from "./TableCell.module.scss";

export interface TableCellProps<Data> {
    cell: Cell<Data, unknown>;
    getCellStyles?: ({ row, column }: { row: Row<Data>; column: { id: string } }) => string[];
}

const TableCell = <Data extends object>({ cell, getCellStyles }: TableCellProps<Data>) => {
    const cellStyles =
        getCellStyles?.({
            row: cell.row,
            column: { id: cell.column.id },
        }) || [];

    return (
        <td align={cell.column.columnDef.meta?.align} className={classNames(styles.td, ...cellStyles)}>
            <Text>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Text>
        </td>
    );
};

export default TableCell;
